/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { Box } from "@mui/material";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import TabComponent from "components/TabComponent";
import Button from "../../components/ButtonUse.jsx";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import useSWR from "swr";
import config from "../../utils/awsCnfig"
import Select from "react-select";
import { baseURL } from "utils/api";
import LoaderComponent from "components/Loader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import tempImage from "../../assets/images/clothes.avif";
import ModalComponent from "components/MDTypography/ModalComponent";
import Snackbar from "@mui/material/Snackbar";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import React from "react";
import { uploadFile } from 'react-s3';
// import "./tables.css";
import placeholder from "../../assets/images/placeholder.png";
window.Buffer = window.Buffer || require("buffer").Buffer;
// import tempImage from "../../assets/images/clothes.jpg";

// import Button from "../../components/ButtonUse.jsx";
// Data

// Dashboard components
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function EditUser() {

  const [colorOptions, setColotherOptions] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      sellingprice: "",
      price: "",
      priceType: "",
      image: "",
      preview: "",
      points: "",
      pointType: "",

      weight: "",
      weightType: "",
    },
  ]);
  console.log(colorOptions)
  const [sizeOptions, setSizeOptions] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      selectedValue: "",
      price: "",
      image: "",
      preview: "",
      priceType: "",
      sellingprice: "",
      points: "",
      pointType: "",
      image: "",
      preview: "",
      weight: "",
      weightType: "",
    },
  ]);
  const [atttribute3, setAttribute3] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      sellingprice: "",
      price: "",
      priceType: "",
      image: "",
      preview: "",
      points: "",
      pointType: "",
      weight: "",
      weightType: "",
    },
  ]);


  const columns = [
    // { field: "id", headerName: "ID", width: 90 },
    {
      field: "Name",
      headerName: "Role Name",
      width: 120,
      editable: true,
    },
    {
      field: "gender",
      headerName: "Gender",
      width: 80,
      editable: true,
    },
    {
      field: "age",
      headerName: "Age",
      width: 80,
      editable: true,
    },
    {
      field: "height",
      headerName: "Height(cm)",
      description: "This column has a value getter and is not sortable.",

      width: 120,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "weight",
      headerName: "Weight(Kg)",
      description: "This column has a value getter and is not sortable.",

      width: 120,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "shoulder",
      headerName: "Shoulder(cm)",
      description: "This column has a value getter and is not sortable.",

      width: 120,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "chest",
      headerName: "Chest(cm)",
      description: "This column has a value getter and is not sortable.",

      width: 120,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "hip",
      headerName: "Hip(cm)",
      description: "This column has a value getter and is not sortable.",

      width: 120,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "foot",
      headerName: "Foot(cm)",
      description: "This column has a value getter and is not sortable.",

      width: 120,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "waist",
      headerName: "Waist(cm)",
      description: "This column has a value getter and is not sortable.",

      width: 120,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];
  const rows = [
    {
      id: 1,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
    {
      id: 2,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
    {
      id: 3,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
    {
      id: 4,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
    {
      id: 5,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
    {
      id: 6,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
    {
      id: 7,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
    {
      id: 8,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
    {
      id: 9,
      Name: "Jon",
      age: 35,
      gender: "Male",
      height: "90",
      weight: "56",
      shoulder: "45",
      foot: "10",
      hip: "23",
      waist: "34",
      chest: "56"
    },
  ];

  //   fetch category names for select option-:

  // const fetchData = async (url) => {
  //   try {
  //     const response = await axios.get(url);
  //     return response.data;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // upload to aws for color options (attribute 1);
  const uploadFiletoS3ColorOptions = async () => {

    try {
      const colorState = [...colorOptions];

      for (let i = 0; i < colorState.length; i++) {
        const file = colorState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          colorState[i].image = location;

          // Exclude the 'preview' property from the state
          delete colorState[i].preview;
        }
      }

      setColotherOptions(colorState);
    } catch (error) {
      console.log(error);
    }

  }
  //  upload to asw s3 for size options(att2)
  const uploadFiletoS3SizeOptions = async () => {
    try {
      const sizeState = [...sizeOptions];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setSizeOptions(sizeState);
    } catch (error) {
      console.log(error);
    }
  }

  // upload to s3 for attribute 3

  const uploadFiletoS3Attr3 = async () => {
    try {
      const sizeState = [...atttribute3];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setAttribute3(sizeState);
    } catch (error) {
      console.log(error);
    }
  }
  const [categoryImages, setCategoryImages] = useState([{
    image: "",
    preview: "",
  }]);

  // upload category images to s3
  const uploadFiletoS3CategoryImg = async () => {
    try {
      const sizeState = [...categoryImages];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setCategoryImages(sizeState);
    } catch (error) {
      console.log(error);
    }
  }

  // const { data, error } = useSWR(`${baseURL}/admin/fetch/categorynames`, fetchData);
  // declare options for react-select
  // const options = data;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => setOpenDialog(false);
  const [category, setCategory] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);
      const imageUrl = URL.createObjectURL(file);
      setPreviewUrl(imageUrl);
    }
  };
  const [attributes, setAttrributes] = useState([
    {
      text: "",
    },
  ]);


  const [productImages, setProductImages] = useState([
    {
      imageUrl: "",
      sortOrder: "",
    },
  ]);



  const [categoryVid, setCategoryVid] = useState("");

  const [formState, setFormState] = useState({

    userId: "",
    userName: "",
    age: "",
    gender: "",
    password: "",
    cpassword: "",
    phone: "",
    email: "",
    refferedby: "",
    status: "",
  });




  // history state-:

  const [history, setHistory] = useState([
    {
      date: "",
      comment: ""
    }
  ]);

  const [transDesc, setTransDesc] = useState("");
  const [amount, setAmount] = useState("");
  const [transaction, setTransation] = useState([
    {
      date: "",
      amount: "",
      description: ""
    }
  ])

  const [comment, setComment] = useState("");


  const [points, setPoints] = useState("");

  const [pointDesc, setPointeDesc] = useState("");

  const [pointsData, setPointsData] = useState([
    {
      date: "",
      description: "",
      points: ""
    }
  ]);
  const tabProps = [

    {
      title: "General",
      content: (
        <DataForm
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          data={formState}
          setFunc={setFormState}
          preview={previewUrl}
          selectedFile={selectedFile}
          handleChange={handleFileChange}
          handleClose={handleClose}
        />
      ),
      id: 2,
    },
    {
      title: "History",
      content: (
        <HistoryForm comment={comment} setComment={setComment} history={history} setHistory={setHistory} />
      ),
      id: 3
    },
    {
      title: "Transation",
      content: (
        <TransationForm transDesc={transDesc} setTransDesc={setTransDesc} amount={amount} setAmount={setAmount} transaction={transaction} setTransation={setTransation} />
      ),
      id: 4
    },

    {
      title: "Reward Points",
      content: (
        <RewardForm pointsData={pointsData} setPointsData={setPointsData} pointDesc={pointDesc} setPointeDesc={setPointeDesc} points={points} setPoints={setPoints} data={formState} />
      ),
      id: 5
    },
    {
      title: "Roles",
      content: (
        <RoleTableComponent rows={rows} columns={columns} />
      ),
      id: 6
    }

  ];

  useEffect(() => {
    async function fetchUser() {
      try {
        setLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/getUser/${location.state}`);
        console.log(res.data.data.referralCode,'DATAAA111111222');
        const data=res.data.data[0]
        setLoading(false);
        setFormState({
          ...formState,
          userId: data._id,
          userName: data.userName,
          email: data.email,
          phone: data.phone,
          password: data.user?.password,
          age: data.age,
          status: data.status,
          refferedby: '',
          gender: data.gender,
          role: data.role,
          referralCode:res.data.data.referralCode

        });
        setHistory(data?.history);
        setTransation(data?.transactions)
        setPointsData(data?.rewardPoints);
      } catch (error) {
        console.log(error);
      }
    }
    fetchUser();
  }, [location.state])

  const createdDate = new Date();
  const createdTime = createdDate.toLocaleTimeString([], { hour12: true });

  console.log(formState.categoryName);
  const updatedDate = new Date().toISOString().split('T')[0];
  const handleUpdteUser = async (e) => {

    e.preventDefault();
    setFormLoading(true);

    try {
      const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/users/editUser/${location.state}`, {
        ...formState,
        history: history,
        transactions: transaction,
        rewardPoints: pointsData,
        updatedDate: updatedDate
      });
      setFormLoading(false);
      navigate("/customers");
    } catch (error) {
      setFormLoading(false);
      console.log(error);
    }



  };



  return (
    <DashboardLayout>
      {/* {loading && <LoaderComponent open={true} />} */}
      {formLoading && <LoaderComponent open={true} />}
      <DashboardNavbar />
      {/* <input type="file" onChange={(e) => setAwsImg(e.target.files[0])} />
      <button onClick={() => uploadFile(awsImg)}>Upload test image</button> */}
      <form
        onSubmit={handleUpdteUser}
        style={{
          background: "white",
          padding: "10px",
          borderRadius: "10px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          overflow: "scroll",
        }}
      >
        <div style={{ display: "flex", gap: "20px", justifyContent: "end" }}>
          <Button title={"Submit"} type={"submit"} background={"green"} />
          <Button
            cliclHandler={() => {
              navigate(-1);
            }}
            title={"Cancel"}
            background={"red"}
            type={"button"}
          />
        </div>

        <TabComponent tabContent={tabProps} />
      </form>

      <Footer />
    </DashboardLayout >
  );
}

export default EditUser;



function DataForm({
  data,
  setFunc,
  preview,
}) {
  return (
    <>
      <div style={{ padding: "5px", paddingBottom: "10vh" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          {console.log(data,'DATAAA111111')}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="USER ID"
            variant="outlined"
            value={data?.userId}
            readonly
            // onChange={(e) => setFunc({ ...data, userId: e.target.value })}
          />




          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Name"
            variant="outlined"
            value={data?.userName}
            onChange={(e) => setFunc({ ...data, userName: e.target.value })}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Referral Code"
            variant="outlined"
            value={data?.referralCode?data?.referralCode:""}
            onChange={(e) => setFunc({ ...data, referralCode: e.target.value })}
          />
          {/* <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Mobile Num"

            variant="outlined"
            value={data?.phone}
            type="text"
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (inputValue === "" || (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)) {
                setFunc({ ...data, phone: inputValue });
              }
            }}
          /> */}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Email"

            variant="outlined"
            type="text"
            value={data?.email}
            onChange={(e) => setFunc({ ...data, email: e.target.value })}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            value={data.age}
            label="Age"
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (inputValue === "" || (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)) {
                setFunc({ ...data, age: inputValue });
              }
            }}
          />

          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Password"
            variant="outlined"

            type="password"
            value={data.password}
            onChange={(e) => setFunc({ ...data, password: e.target.value })}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}

            label="Confirm"
            variant="outlined"
            type="text"
            value={data?.cpassword}
            onChange={(e) => setFunc({ ...data, cpassword: e.target.value })}
          />



          <div className="flex flex-col">
            <span>Gender</span>
            <select value={data.gender} onChange={(e) => setFunc({ ...data, gender: e.target.value })} className="h-[7vh] w-[20vw] p-2" id="">
              <option>Select</option>
              <option>Male</option>
              <option>Female</option>
            </select>
          </div>
          <div className="flex flex-col">
            <span>Role</span>
            <select value={data.role} onChange={(e) => setFunc({ ...data, role: e.target.value })} className="h-[7vh] w-[20vw] p-2" id="">
              <option>Select</option>
              <option value="User">User</option>
              <option value="Admin">Admin</option>
              <option value="Superadmin">Super Admin</option>
            </select>
          </div>



          {/* <div className="mt-4 flex flex-col gap-3">
            <span>Requires Shipping</span>
            <div className="flex gap-2">
              <div className="flex gap-2">
                <label htmlFor="">Train</label>
                <input type="radio" />
              </div>
              <div className="flex gap-2">
                <label htmlFor="">Air</label>
                <input type="radio" />
              </div>
            </div>
          </div> */}
          {/* <div className="flex flex-col gap-3">
            <span>Date Available</span>
            <input type="date" className="w-[30vw] h-[4vh]" />
          </div> */}





          {/* <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
            <span>Status</span>
            <select value={data.status} onChange={(e) => setFunc({ ...data, status: e.target.value })} style={{ width: "20vw", height: "7vh" }} name="" id="">
              <option>Select</option>
              <option>Enabled</option>
              <option>Disabled</option>
            </select>
          </div> */}
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}

            label="Reffered By"
            variant="outlined"
            type="text"
            value={data?.refferedby}
            onChange={(e) => setFunc({ ...data, refferedby: e.target.value })}
          />
        </div>
      </div>
    </>
  );
}



// history table form-:

function HistoryForm({ history, comment, setComment, setHistory }) {

  const date = new Date().toISOString().split('T')[0];

  const addMoreHistory = () => {
    const newData = [...history];
    newData.push({
      date: date,
      comment: comment,
    });
    setHistory(newData);
    setComment("")
  }

  const handleChangeHistory = (index, name, value) => {
    const newData = [...history];
    newData[index][name] = value;
    setHistory(newData);
  }

  return (
    <>
      <section className="p-6">
        <div style={{ width: '100%', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ width: '50%', padding: '10px', border: '1px solid #ddd', fontSize: '0.8rem' }}>Date added</th>
                <th style={{ width: '50%', padding: '10px', border: '1px solid #ddd', fontSize: '0.8rem' }}>Comment</th>
              </tr>
            </thead>
            <tbody>
              {console.log(history,'History')}
              {history?.map((record, index) => (
                <tr key={index}>
                  <td style={{ padding: '10px', border: '1px solid #ddd', fontSize: "0.8rem" }}>{record.date}</td>
                  <td style={{ padding: '10px', border: '1px solid #ddd', fontSize: "0.8rem" }}>{record.comment}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex mt-10 flex-col gap-3">
          <span className="text-sm">Add History</span>
          <textarea className="p-4 pl-6" name="history" value={comment} onChange={(e) => setComment(e.target.value)} id="" cols="30" rows="10"></textarea>
        </div>
        <div className="flex justify-end mt-4">
          <Button cliclHandler={addMoreHistory} type={"button"} background={"blue"} color={"white"} title={'Add History'} />
        </div>

      </section>
    </>
  )
}



function TransationForm({ transaction, amount, setAmount, setTransation, transDesc, setTransDesc }) {

  const date = new Date().toISOString().split('T')[0];

  const addMoreHistory = () => {
    const newData = [...transaction];
    newData.push({
      date: date,
      description: transDesc,
      amount: amount
    });
    setTransation(newData);
    setTransDesc("");
    setAmount("");
  }

  const handleChangeTransation = (index, name, value) => {
    const newData = [...transaction];
    newData[index][name] = value;
    setTransDesc(newData);
  }

  return (
    <>
      <section className="p-6">
        <div style={{ width: '100%', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ width: '50%', padding: '10px', border: '1px solid #ddd', fontSize: '0.8rem' }}>Date added</th>
                <th style={{ width: '50%', padding: '10px', border: '1px solid #ddd', fontSize: '0.8rem' }}>Description</th>
                <th style={{ width: '50%', padding: '10px', border: '1px solid #ddd', fontSize: '0.8rem' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {transaction.map((record, index) => (
                <tr key={index}>
                  <td style={{ padding: '10px', border: '1px solid #ddd', fontSize: "0.8rem" }}>{record.date}</td>
                  <td style={{ padding: '10px', border: '1px solid #ddd', fontSize: "0.8rem" }}>{record.description}</td>
                  <td style={{ padding: '10px', border: '1px solid #ddd', fontSize: "0.8rem" }}>{record.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex mt-10 flex-col gap-3">
          <span className="text-sm">Add Transation</span>
          <div className="flex flex-col gap-2 mt-4">
            <span className="font-bold text-sm">Description</span>
            <textarea className="p-4 pl-2" name="description" value={transDesc} onChange={(e) => setTransDesc(e.target.value)} id="" cols="30" rows="10"></textarea>
            <div className="flex flex-col gap-3">
              <span className="font-bold text-sm">Amount</span>
              <input type="text" className="h-[6vh] w-[30vw] pl-4" value={amount} onChange={(e) => setAmount(e.target.value)} />
            </div>

          </div>
        </div>
        <div className="flex justify-end mt-4">
          <Button cliclHandler={addMoreHistory} type={"button"} background={"blue"} color={"white"} title={'Add Transation'} />
        </div>

      </section>
    </>
  )
}




function RewardForm({ pointsData, setPointsData, pointDesc, setPointeDesc, points, setPoints,data }) {

  const date = new Date().toISOString().split('T')[0];

  const addMorePoints =async () => {
    const newData = [...pointsData]; // Assuming pointsData is the state you want to update
    newData.push({
      date: date, // Assuming date is a variable holding the current date
      description: pointDesc,
      points: points // Assuming points is a variable holding the current points value
    });
    setPointsData(newData);
    setPointeDesc(""); // Assuming setPointDesc is a function to update the pointDesc state
    setPoints(""); // Assuming setPoints is a function to update the points state
    // setTransDesc("");
    // setAmount("");
    const apidata={
      "userId":data.userId,
      "points":points,
      "reason":"BYSUPERADMIN"
    }
    const resp= await axios.post(`${process.env.REACT_APP_BASE_URL}/users/giveRewardPointsToUser`,apidata);
  }

  console.log(data.userId,'PPPPPPPPOOOO')

  return (
    <>
      <section className="p-6">
        <div style={{ width: '100%', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ width: '50%', padding: '10px', border: '1px solid #ddd', fontSize: '0.8rem' }}>Date added</th>
                <th style={{ width: '50%', padding: '10px', border: '1px solid #ddd', fontSize: '0.8rem' }}>Description</th>
                <th style={{ width: '50%', padding: '10px', border: '1px solid #ddd', fontSize: '0.8rem' }}>Points</th>
              </tr>
            </thead>
            <tbody>
              {pointsData.map((record, index) => (
                <tr>
                  <td style={{ padding: '10px', border: '1px solid #ddd', fontSize: "0.8rem" }}>{record.date}</td>
                  <td style={{ padding: '10px', border: '1px solid #ddd', fontSize: "0.8rem" }}>{record.description}</td>
                  <td style={{ padding: '10px', border: '1px solid #ddd', fontSize: "0.8rem" }}>{record.points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex mt-10 flex-col gap-3">
          <span className="text-sm">Add Reward Points</span>
          <div className="flex flex-col gap-2 mt-4">
            <span className="font-bold text-sm">Description</span>
            <textarea value={pointDesc} onChange={(e) => setPointeDesc(e.target.value)} className="p-4 pl-2" name="description" id="" cols="30" rows="10"></textarea>
            <div className="flex flex-col gap-3">
              <span className="font-bold text-sm">Points</span>
              <input value={points} onChange={(e) => setPoints(e.target.value)} type="text" className="h-[6vh] w-[30vw] pl-4" />
            </div>

          </div>
        </div>
        <div className="flex justify-end mt-4">
          <Button cliclHandler={addMorePoints} type={"button"} background={"blue"} color={"white"} title={'Add Transation'} />
        </div>

      </section>
    </>
  )
}


const RoleTableComponent = ({ rows, columns }) => {
  return (
    <>
      <Box sx={{ height: 400, width: "100%", background: "white" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5, 10, 100]}
          checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
    </>
  )
}